import { toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-6cff917d"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "field" }
const _hoisted_2 = /*#__PURE__*/_createTextVNode(" Will render ")
const _hoisted_3 = { key: 0 }
const _hoisted_4 = { class: "field" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, "Selected Inputs", -1))
const _hoisted_6 = { class: "selectedInputsContainer" }
const _hoisted_7 = { class: "section" }
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "title" }, " Selected ", -1))
const _hoisted_9 = { class: "content" }
const _hoisted_10 = ["onClick"]
const _hoisted_11 = { class: "section" }
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "title" }, " Available ", -1))
const _hoisted_13 = { class: "content" }
const _hoisted_14 = ["onClick"]
const _hoisted_15 = { class: "field" }
const _hoisted_16 = { class: "control" }
const _hoisted_17 = ["disabled"]
const _hoisted_18 = {
  key: 0,
  class: "field"
}
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "Result" }, " Result: ", -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ExportRenderContainer = _resolveComponent("ExportRenderContainer")!
  const _component_PanelAttribute = _resolveComponent("PanelAttribute")!
  const _component_Panel = _resolveComponent("Panel")!

  return (_openBlock(), _createBlock(_component_Panel, { title: "Export Multiple" }, {
    default: _withCtx(() => [
      (_ctx.pkg)
        ? (_openBlock(), _createBlock(_component_PanelAttribute, { key: 0 }, {
            default: _withCtx(() => [
              _createElementVNode("div", _hoisted_1, [
                _hoisted_2,
                (_ctx.viewKey)
                  ? (_openBlock(), _createElementBlock("code", _hoisted_3, _toDisplayString(_ctx.viewKey), 1))
                  : _createCommentVNode("", true)
              ]),
              _createElementVNode("div", _hoisted_4, [
                _hoisted_5,
                _createElementVNode("div", _hoisted_6, [
                  _createElementVNode("div", _hoisted_7, [
                    _hoisted_8,
                    _createElementVNode("div", _hoisted_9, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.selectedArguments, (args, index) => {
                        return (_openBlock(), _createElementBlock("div", { key: index }, [
                          (_ctx.selectedArguments.includes(args))
                            ? (_openBlock(), _createElementBlock("div", {
                                key: 0,
                                class: "argument",
                                onClick: ($event: any) => (_ctx.removeArgs(args))
                              }, _toDisplayString(args.name), 9, _hoisted_10))
                            : _createCommentVNode("", true)
                        ]))
                      }), 128))
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_11, [
                    _hoisted_12,
                    _createElementVNode("div", _hoisted_13, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.previewArguments, (args, index) => {
                        return (_openBlock(), _createElementBlock("div", { key: index }, [
                          (!_ctx.selectedArguments.includes(args))
                            ? (_openBlock(), _createElementBlock("div", {
                                key: 0,
                                class: "argument",
                                onClick: ($event: any) => (_ctx.addArgs(args))
                              }, _toDisplayString(args.name), 9, _hoisted_14))
                            : _createCommentVNode("", true)
                        ]))
                      }), 128))
                    ])
                  ])
                ])
              ]),
              _createElementVNode("div", _hoisted_15, [
                _createElementVNode("div", _hoisted_16, [
                  _createElementVNode("button", {
                    class: "button is-small",
                    onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.runExport())),
                    disabled: _ctx.selectedArguments.length === 0 || !_ctx.viewKey
                  }, " Export ", 8, _hoisted_17)
                ])
              ]),
              (_ctx.exporting)
                ? (_openBlock(), _createElementBlock("div", _hoisted_18, [
                    _hoisted_19,
                    _createVNode(_component_ExportRenderContainer, {
                      exporting: _ctx.exporting,
                      pkg: _ctx.pkg,
                      renderView: [_ctx.renderView],
                      previewArguments: _ctx.selectedArguments
                    }, null, 8, ["exporting", "pkg", "renderView", "previewArguments"])
                  ]))
                : _createCommentVNode("", true)
            ]),
            _: 1
          }))
        : _createCommentVNode("", true)
    ]),
    _: 1
  }))
}